import withIconProps from '../withIconProps';

import FeaturesBonusProgram from '../_raw/features/icon_features_bonus_program.svg';

export default withIconProps(FeaturesBonusProgram, { shouldSetDefaultSize: false });
